// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__AY1gl","rotation":"SmallLoader_rotation__ihbxu"};